/**
 * Boolean control - single toggle button that highlights when on
 */

import React from 'react';

interface BooleanControlProps {
  value: boolean;
  color: string;
  onChange: (value: boolean) => void;
}

export function BooleanControl({ value, color, onChange }: BooleanControlProps) {
  return (
    <button
      onClick={() => onChange(!value)}
      style={{
        width: 40,
        height: 20,
        background: 'transparent',
        border: 'none',
        borderRadius: 4,
        color: value ? 'white' : '#9ca3af',
        fontSize: 11,
        cursor: 'pointer',
        transition: 'all 0.1s ease'
      }}
    >
      {value ? 'ON' : 'OFF'}
    </button>
  );
}
